import React from 'react'

export interface IconChevronUpProps {
    width: number
    height: number
    title?: string
    className?: string
    stroke?: string
}

export const IconChevronUp: React.FC<IconChevronUpProps> = ({
    width,
    height,
    stroke = '#161616',
}) => (
    <svg viewBox="0 0 24 25" fill="none" width={width} height={height}>
        <path
            d="M18 15.104L12 9.104L6 15.104"
            stroke={stroke}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
